import React, {Component} from 'react';
import '../assets/css/main.css';
import ReactGA from "react-ga";
import {
    isIE
} from "react-device-detect";
import {IMG_URL} from '../config'

class Warning extends Component {
    state = {
        success_count: 0,
        fail_count: 0,
        is_load: false,
    }

    componentDidMount() {
        ReactGA.pageview('/mask/warning')
        this.timeout = setTimeout(() => {
            this.setState({is_load: true})
        }, 1500)
    }

    goStory() {
        ReactGA.event({
            category: "Story-2 [가면테스트]",
            action: "Start",
            label: "시작"
        });
        this.props.history.push("/play");
    }

    goBack() {
        ReactGA.event({
            category: "Story-2 [가면테스트]",
            action: "Give Up",
            label: "포기"
        });
        this.props.history.push("/");
    }

    render() {
        let ie_msg;
        if (isIE) {
            ie_msg = "해당 검사는 해당브라우저를 지원하지 않습니다. 다른 브라우저를 사용해주세요."
        }
        let go_btn =
            <>
                <button className="main_start_btn" style={{opacity: 0, cursor: "default"}}>알겠습니다.
                </button>
                <br/>
                <p className="warning_back" style={{opacity: 0, cursor: "default"}}>겁이 나서 못하겠어요..</p>
            </>
        if (this.state.is_load) {
            go_btn =
                <>
                    <button className="main_start_btn fade_in" onClick={() => this.goStory()}>알겠습니다.
                    </button>
                    <br/>
                    <p className="warning_back fade_in" onClick={() => this.goBack()}>겁이 나서 못하겠어요..</p>
                </>
        }
        return (
            <div className="warning">
                {
                    ie_msg &&
                    <p className="ie_msg">{ie_msg}</p>
                }
                <div className="main_wrapper">
                    <div className="warning_opacity_div fade_in">
                        <img className="warning_icon" alt="warning_icon"
                             src={IMG_URL + '/story/story_2/main/warning_icon.png'}/>
                        <p className="warning_title">공포에 대한 경고</p>
                        <p className="warning_desc">깜놀할 수 있는 장면을 마주칠 수 있습니다.<br/>이로 인한 문제는 책임지지 않으니,
                            <br/>
                            심약자 및 임산부는 체험에 참고해주세요.</p>
                        {go_btn}
                    </div>
                </div>
            </div>
        )
    }
}

export default Warning;
